import React from "react";
import { produce, setAutoFreeze } from "immer";
import { Auth } from "aws-amplify";
import API from "./services/API";

setAutoFreeze(false);

const getEmptyUser = () => ({
  accountId: "",
  userId: "",
  email: "",
  firstName: "",
  lastName: "",
  nickName: "",
  phoneNumber: "",
  active: false,
  language: "",
  parameters: "",
  isAccountAdmin: false
});

const initialContextValue: IGlobalContextProps = {
  locale: "es",
  user: getEmptyUser(),
  applications: [],
  applicationsGroups: [],
  setLocale: () => {},
  getUserAttributes: () => {},
  listUserApplications: () => {}
};

export const GlobalContext = React.createContext<IGlobalContextProps>(initialContextValue);
export const GlobalContextConsumer = GlobalContext.Consumer;

export class GlobalContextProvider extends React.Component<any, IGlobalContextProviderState> {
  state: IGlobalContextProviderState = {
    locale: "es",
    user: getEmptyUser(),
    applications: [],
    applicationsGroups: []
  };

  componentDidMount = () => {
    this.handleLoadUserAttributes();
  };

  handleListUserApplications = async () => {
    try {
      const applications = await API.userListApplications();
      const groups = [...Array.from(new Set(applications.map(({ group }) => group)))];
      groups.sort();
      const applicationsGroups = groups.map((group) => {
        const groupApplications = applications.filter((app) => app.group === group);
        groupApplications.sort((a, b) => {
          if (a.label > b.label) return 1;
          if (a.label < b.label) return -1;
          return 0;
        });
        return {
          group,
          applications: groupApplications
        };
      });
      this.setState({
        applications,
        applicationsGroups
      });
    } catch (e) {
      console.log(e);
    }
  };

  handleLoadUserAttributes = async () => {
    try {
      const idTokenPayload = (await Auth.currentSession()).getIdToken().payload as IIdTokenPayload;
      console.log("Loading User: ", idTokenPayload.email);
      const user = await API.userGetUser(idTokenPayload.sub);

      this.setState(
        produce((draft: IGlobalContextProviderState) => {
          draft.user = user;
        })
      );
      this.handleListUserApplications();
    } catch (e) {
      console.log("USER NOT FOUND");
      localStorage.removeItem("KetricsApplicationsRefreshToken");
      await Auth.signOut();
    }
  };

  handleSetLocale = (locale: string) => {
    this.setState({ locale });
  };

  render() {
    return (
      <GlobalContext.Provider
        value={{
          user: this.state.user,
          locale: this.state.locale,
          applications: this.state.applications,
          applicationsGroups: this.state.applicationsGroups,
          setLocale: this.handleSetLocale,
          getUserAttributes: this.handleLoadUserAttributes,
          listUserApplications: this.handleListUserApplications
        }}
      >
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}
